// Chakra imports
import {
  Button,
  Flex,
  FormControl,
  FormLabel,
  Input,
  Select,
  Text,
  useColorModeValue,
  Grid,
  GridItem,
  Center,
  Spinner,
  Modal,
  ModalOverlay,
  ModalHeader,
  ModalBody,
  ModalContent,
  ModalFooter,
  Badge,
} from "@chakra-ui/react";
import { CheckIcon, InfoIcon } from "@chakra-ui/icons";
import React, { useState, useEffect } from "react";
import axios from "axios";
import { decryptData, URL_WEB_BACKEND } from "CustomUtil";
import Card from "components/card/Card.js";
import { HSeparator } from "components/separator/Separator";
import DetailKenaikanPegawai from "./DetailKenaikanPegawai";

export default function UpTable({ onRefresh, refreshing, detail }) {
  const authdata = decryptData(localStorage.getItem("authinfosemakinpas"));

  const textColorPrimary = useColorModeValue("secondaryGray.900", "white");
  const textColorSecondary = "gray.400";

  const [statusLoading, setStatusLoading] = useState(false);
  const [titleDialog, setTitleDialog] = useState("title");
  const [descDialog, setDescDialog] = useState("desc");
  const [statusInfoDialog, setStatusInfoDialog] = useState(false);
  const [infoDialogIcon, setInfoDialogIcon] = useState(1);
  const [isNewData, setIsNewData] = useState(false);
  const [kepegawaian, setKepegawaian] = useState({
    id: null,
    jenis_kelamin: "",
    pangkat_golongan: "",
    pendidikan_terakhir: "",
    eselon: "",
    jabatan: "",
    hukdis: "",
    lama_hukdis: "",
    tmt_pangkat_terakhir: "",
    tmt_gaji_terakhir: "",
  });

  useEffect(() => {
    setStatusLoading(true);
    if (!refreshing) {
      setStatusLoading(false);
      if (detail.kepegawaian && detail.kepegawaian.id) {
        setIsNewData(false);
        setKepegawaian({
          id: detail.kepegawaian.id,
          jenis_kelamin: detail.kepegawaian.jenis_kelamin || "",
          pangkat_golongan: detail.kepegawaian.pangkat_golongan || "",
          pendidikan_terakhir: detail.kepegawaian.pendidikan_terakhir || "",
          eselon: detail.kepegawaian.eselon || "",
          jabatan: detail.kepegawaian.jabatan || "",
          hukdis: detail.kepegawaian.hukdis || "",
          lama_hukdis: detail.kepegawaian.lama_hukdis || "",
          tmt_pangkat_terakhir: detail.kepegawaian.tmt_pangkat_terakhir || "",
          tmt_gaji_terakhir: detail.kepegawaian.tmt_gaji_terakhir || "",
        });
      } else {
        setIsNewData(true);
        setKepegawaian({
          id: null,
          jenis_kelamin: "",
          pangkat_golongan: "",
          pendidikan_terakhir: "",
          eselon: "",
          jabatan: "",
          hukdis: "",
          lama_hukdis: "",
          tmt_pangkat_terakhir: "",
          tmt_gaji_terakhir: "",
        });
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [detail]);

  useEffect(() => {
    if (refreshing) {
      refreshData();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [refreshing]);

  const refreshData = async () => {
    setStatusLoading(true);
    try {
      const res = await axios.get(
        `${URL_WEB_BACKEND}/kepegawaians/${detail.userid}`,
        {
          headers: {
            Authorization: "Bearer " + authdata,
          },
        }
      );

      setIsNewData(false);
      setKepegawaian({
        id: res.data.id,
        jenis_kelamin: res.data.jenis_kelamin || "",
        pangkat_golongan: res.data.pangkat_golongan || "",
        pendidikan_terakhir: res.data.pendidikan_terakhir || "",
        eselon: res.data.eselon || "",
        jabatan: res.data.jabatan || "",
        hukdis: res.data.hukdis || "",
        lama_hukdis: res.data.lama_hukdis || "",
        tmt_pangkat_terakhir: res.data.tmt_pangkat_terakhir || "",
        tmt_gaji_terakhir: res.data.tmt_gaji_terakhir || "",
      });
    } catch (err) {
      if (err.response && err.response.status === 404) {
        console.log("Data kepegawaian belum ada, mode CREATE");
        setIsNewData(true);
        setKepegawaian({
          id: null,
          jenis_kelamin: "",
          pangkat_golongan: "",
          pendidikan_terakhir: "",
          eselon: "",
          jabatan: "",
          hukdis: "",
          lama_hukdis: "",
          tmt_pangkat_terakhir: "",
          tmt_gaji_terakhir: "",
        });
      } else {
        console.error("Error fetching kepegawaian:", err);
        showInfoDialog("Error", "Gagal memuat data kepegawaian", 1);
      }
    } finally {
      setStatusLoading(false);
    }
  };

  const showInfoDialog = (title, desc, infoicon) => {
    setTitleDialog(title);
    setDescDialog(desc);
    setInfoDialogIcon(infoicon);
    setStatusInfoDialog(true);
  };

  const saveData = async () => {
    if (!kepegawaian.jenis_kelamin || !kepegawaian.pendidikan_terakhir || !kepegawaian.jabatan) {
      showInfoDialog(
        "Gagal",
        "Mohon lengkapi data yang wajib diisi (Jenis Kelamin, Pendidikan Terakhir, Jabatan)",
        1
      );
      return;
    }

    setStatusLoading(true);
    try {
      let formData = new FormData();
      formData.append("id_user", detail.userid);
      formData.append("jenis_kelamin", kepegawaian.jenis_kelamin);
      formData.append("pangkat_golongan", kepegawaian.pangkat_golongan || "");
      formData.append("pendidikan_terakhir", kepegawaian.pendidikan_terakhir);
      formData.append("eselon", kepegawaian.eselon || "");
      formData.append("jabatan", kepegawaian.jabatan);
      formData.append("hukdis", kepegawaian.hukdis || "");
      formData.append("lama_hukdis", kepegawaian.lama_hukdis || "");
      formData.append("tmt_pangkat_terakhir", kepegawaian.tmt_pangkat_terakhir || "");
      formData.append("tmt_gaji_terakhir", kepegawaian.tmt_gaji_terakhir || "");

      let response;

      if (isNewData) {
        console.log("Mode: CREATE data baru");
        response = await axios.post(
          `${URL_WEB_BACKEND}/kepegawaians`,
          formData,
          {
            headers: {
              Authorization: "Bearer " + authdata,
              "Content-Type": "multipart/form-data",
            },
          }
        );
        showInfoDialog("Berhasil", "Data kepegawaian berhasil ditambahkan", 0);
      } else {
        console.log("Mode: UPDATE data existing");
        formData.append("id", kepegawaian.id);
        response = await axios.post(
          `${URL_WEB_BACKEND}/updatedatakepegawaian`,
          formData,
          {
            headers: {
              Authorization: "Bearer " + authdata,
              "Content-Type": "multipart/form-data",
            },
          }
        );
        showInfoDialog("Berhasil", "Data kepegawaian berhasil diupdate", 0);
      }

      console.log("Response:", response.data);
      onRefresh();
    } catch (err) {
      console.error("Save error:", err);
      let errorMsg = "Gagal menyimpan data kepegawaian";
      if (err.response) {
        if (err.response.status === 400) {
          const errors = err.response.data;
          if (typeof errors === "object" && !errors.message) {
            errorMsg = Object.values(errors).flat().join(", ");
          } else if (errors.message) {
            errorMsg = errors.message;
          }
        } else if (err.response.status === 404) {
          errorMsg = "Data tidak ditemukan";
        } else if (err.response.status === 401) {
          errorMsg = "Sesi Anda telah berakhir. Silakan login kembali.";
        }
      }
      showInfoDialog("Gagal", errorMsg, 1);
    } finally {
      setStatusLoading(false);
    }
  };

  const viewInfoDialog = () => (
    <Modal closeOnOverlayClick={true} isCentered isOpen={statusInfoDialog}>
      <ModalOverlay bg="blackAlpha.300" backdropFilter="blur(10px) hue-rotate(10deg)" />
      <ModalContent>
        <ModalHeader>{titleDialog}</ModalHeader>
        <ModalBody>
          <Center>
            {infoDialogIcon ? (
              <InfoIcon w={16} h={16} color="blue.500" />
            ) : (
              <CheckIcon w={16} h={16} color="green.500" />
            )}
          </Center>
          <Center mt={8}>
            <Text fontSize="large">{descDialog}</Text>
          </Center>
        </ModalBody>
        <ModalFooter>
          <Button onClick={() => setStatusInfoDialog(false)}>OK</Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );

  const handleChange = (field, value) => {
    setKepegawaian({ ...kepegawaian, [field]: value });
  };

  return (
    <>
      <br />
      <Card align="center" p="20px">
        {viewInfoDialog()}

        {statusLoading ? (
          <Center mb={6}>
            <Spinner
              thickness="4px"
              speed="0.95s"
              emptyColor="gray.200"
              color="blue.500"
              size="xl"
            />
          </Center>
        ) : (
          <Flex direction="column" w="100%">
            <Flex justify="space-between" align="center" mb={2}>
              <Text color={textColorPrimary} fontSize="2xl" fontWeight="bold">
                Rincian Data
              </Text>
              <Badge colorScheme={isNewData ? "green" : "blue"} fontSize="sm" px={3} py={1}>
                {isNewData ? "DATA BARU" : "EDIT DATA"}
              </Badge>
            </Flex>

            <Text
              color={textColorPrimary}
              fontSize='md'
              my={{ base: "auto", "2xl": "10px" }}
              textAlign='start'>
              NIP&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;:&nbsp;&nbsp;{detail.username.toUpperCase()}
            </Text>
            <Text
              color={textColorPrimary}
              fontSize='md'
              my={{ base: "auto", "2xl": "10px" }}
              textAlign='start'>
              Nama&nbsp;&nbsp;&nbsp;&nbsp;:&nbsp;&nbsp;{detail.fullname.toUpperCase()}
            </Text>

            <HSeparator mb={4} />

            <Grid templateColumns={{ base: "1fr", md: "1fr 1fr" }} gap={4}>
              <GridItem>
                <FormControl isRequired>
                  <FormLabel>Jenis Kelamin</FormLabel>
                  <Select
                    placeholder="Pilih Jenis Kelamin"
                    value={kepegawaian.jenis_kelamin || ""}
                    onChange={(e) => handleChange("jenis_kelamin", e.target.value)}
                  >
                    <option value="L">Laki-laki</option>
                    <option value="P">Perempuan</option>
                  </Select>
                </FormControl>
              </GridItem>

              <GridItem>
                <FormControl>
                  <FormLabel>Pangkat / Golongan</FormLabel>
                  <Select
                    placeholder="Pilih Pangkat / Golongan"
                    value={kepegawaian.pangkat_golongan || ""}
                    onChange={(e) => handleChange("pangkat_golongan", e.target.value)}
                  >
                    <optgroup label="Golongan I">
                      <option value="Juru Muda (I/a)">Juru Muda (I/a)</option>
                      <option value="Juru Muda Tingkat I (I/b)">Juru Muda Tingkat I (I/b)</option>
                      <option value="Juru (I/c)">Juru (I/c)</option>
                      <option value="Juru Tingkat I (I/d)">Juru Tingkat I (I/d)</option>
                    </optgroup>

                    <optgroup label="Golongan II">
                      <option value="Pengatur Muda (II/a)">Pengatur Muda (II/a)</option>
                      <option value="Pengatur Muda Tingkat I (II/b)">Pengatur Muda Tingkat I (II/b)</option>
                      <option value="Pengatur (II/c)">Pengatur (II/c)</option>
                      <option value="Pengatur Tingkat I (II/d)">Pengatur Tingkat I (II/d)</option>
                    </optgroup>

                    <optgroup label="Golongan III">
                      <option value="Penata Muda (III/a)">Penata Muda (III/a)</option>
                      <option value="Penata Muda Tingkat I (III/b)">Penata Muda Tingkat I (III/b)</option>
                      <option value="Penata (III/c)">Penata (III/c)</option>
                      <option value="Penata Tingkat I (III/d)">Penata Tingkat I (III/d)</option>
                    </optgroup>

                    <optgroup label="Golongan IV">
                      <option value="Pembina (IV/a)">Pembina (IV/a)</option>
                      <option value="Pembina Tingkat I (IV/b)">Pembina Tingkat I (IV/b)</option>
                      <option value="Pembina Utama Muda (IV/c)">Pembina Utama Muda (IV/c)</option>
                      <option value="Pembina Utama Madya (IV/d)">Pembina Utama Madya (IV/d)</option>
                      <option value="Pembina Utama (IV/e)">Pembina Utama (IV/e)</option>
                    </optgroup>
                  </Select>
                </FormControl>
              </GridItem>

              <GridItem>
                <FormControl isRequired>
                  <FormLabel>Pendidikan Terakhir</FormLabel>
                  <Select
                    placeholder="Pilih Pendidikan Terakhir"
                    value={kepegawaian.pendidikan_terakhir || ""}
                    onChange={(e) => handleChange("pendidikan_terakhir", e.target.value)}
                  >
                    <option value="SMP">SMP / Sederajat</option>
                    <option value="SMA">SMA / Sederajat</option>
                    <option value="SMK">SMK</option>
                    <option value="D1">Diploma I (D1)</option>
                    <option value="D2">Diploma II (D2)</option>
                    <option value="D3">Diploma III (D3)</option>
                    <option value="D4">Diploma IV (D4)</option>
                    <option value="S1">Sarjana (S1)</option>
                    <option value="S2">Magister (S2)</option>
                    <option value="S3">Doktor (S3)</option>
                    <option value="Profesor">Profesor</option>
                  </Select>
                </FormControl>
              </GridItem>

              <GridItem>
                <FormControl>
                  <FormLabel>Eselon</FormLabel>
                  <Input
                    value={kepegawaian.eselon || ""}
                    onChange={(e) => handleChange("eselon", e.target.value)}
                  />
                </FormControl>
              </GridItem>

              <GridItem>
                <FormControl isRequired>
                  <FormLabel>Jabatan</FormLabel>
                  <Input
                    value={kepegawaian.jabatan || ""}
                    onChange={(e) => handleChange("jabatan", e.target.value)}
                  />
                </FormControl>
              </GridItem>

              <GridItem>
                <FormControl>
                  <FormLabel>Hukuman Disiplin</FormLabel>
                  <Input
                    value={kepegawaian.hukdis || ""}
                    onChange={(e) => handleChange("hukdis", e.target.value)}
                  />
                </FormControl>
              </GridItem>

              <GridItem>
                <FormControl>
                  <FormLabel>Lama Hukdis (bulan)</FormLabel>
                  <Input
                    type="number"
                    value={kepegawaian.lama_hukdis || ""}
                    onChange={(e) => handleChange("lama_hukdis", e.target.value)}
                  />
                </FormControl>
              </GridItem>

              {/* ✅ Input tanggal sudah ada dan aktif */}
              <GridItem>
                <FormControl>
                  <FormLabel>TMT Pangkat Terakhir</FormLabel>
                  <Input
                    type="date"
                    value={kepegawaian.tmt_pangkat_terakhir || ""}
                    onChange={(e) => handleChange("tmt_pangkat_terakhir", e.target.value)}
                  />
                </FormControl>
              </GridItem>

              <GridItem>
                <FormControl>
                  <FormLabel>TMT Gaji Terakhir</FormLabel>
                  <Input
                    type="date"
                    value={kepegawaian.tmt_gaji_terakhir || ""}
                    onChange={(e) => handleChange("tmt_gaji_terakhir", e.target.value)}
                  />
                </FormControl>
              </GridItem>
            </Grid>

            <Button
              w="100%"
              colorScheme={isNewData ? "green" : "blue"}
              mt={6}
              onClick={() => saveData()}
            >
              {isNewData ? "TAMBAH DATA" : "SIMPAN PERUBAHAN"}
            </Button>
          </Flex>
        )}
      </Card>
      <br />
      <Card align="center" p="20px">
        {statusLoading ? (
          <Center py={8}>
            <Spinner
              thickness="4px"
              speed="0.95s"
              emptyColor="gray.200"
              color="blue.500"
              size="xl"
            />
          </Center>
        ) : kepegawaian.id ? (
          <DetailKenaikanPegawai kepegawaian={kepegawaian} />
        ) : (
          <Center py={8}>
            <Text fontSize="sm" color={textColorSecondary}>
              Simpan data kepegawaian terlebih dahulu untuk melihat informasi kenaikan pangkat dan gaji berkala.
            </Text>
          </Center>
        )}
      </Card>
    </>
  );
}